var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.hasForms
    ? _c("div", { staticClass: "more_form_container my-3" }, [
        _c("p", [_vm._v(_vm._s(_vm.multiLanguage.ProductOtherForms))]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "other-forms-group mt-2 mb-3 d-flex align-items-center overflow-auto",
            staticStyle: { gap: "10px" },
          },
          _vm._l(_vm.formItems, function (item, index) {
            return _c("div", { key: index, staticClass: "item" }, [
              item.picUrl && item.url
                ? _c("a", { attrs: { href: item.url, "aria-label": "Form" } }, [
                    _c("img", {
                      attrs: {
                        src: item.picUrl,
                        alt: "Form",
                        width: "45",
                        height: "45",
                        loading: "lazy",
                        decoding: "async",
                      },
                    }),
                  ])
                : _vm._e(),
            ])
          }),
          0
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }